import { render, staticRenderFns } from "./SeriesHistoryStats.vue?vue&type=template&id=17bf8474&scoped=true"
import script from "./SeriesHistoryStats.vue?vue&type=script&lang=js"
export * from "./SeriesHistoryStats.vue?vue&type=script&lang=js"
import style0 from "./SeriesHistoryStats.vue?vue&type=style&index=0&id=17bf8474&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17bf8474",
  null
  
)

export default component.exports